import Anchor from '@/components/ui/Anchor'
import Icon from '@/components/ui/Icon'
import { useData } from '@/hooks/useLocale'

/** The card under the release notes asking visitors to report a bug. */
export default function ReportIssue() {
  const { UPDATES } = useData()
  const { report } = UPDATES

  return (
    <div className="flex flex-wrap items-center gap-5 rounded-3xl bg-[#f6f8fb] p-7">
      <span className="grid size-12 shrink-0 place-items-center rounded-[14px] bg-[#fdecea] text-[#c5221f]">
        <Icon name="bug" size={22} stroke={1.8} />
      </span>
      <div className="flex min-w-60 flex-1 flex-col gap-1">
        <h2 className="text-[19px] font-semibold tracking-[-0.01em] text-ink">
          {report.title}
        </h2>
        <p className="text-[15px]/[1.6] text-muted">{report.text}</p>
      </div>
      <Anchor
        href={report.cta.href}
        className="flex h-[46px] shrink-0 items-center gap-2.5 rounded-full bg-ink px-5 text-sm font-semibold text-white hover:bg-brand"
      >
        {report.cta.label}
        <Icon name="arrowRight" size={14} stroke={2.4} />
      </Anchor>
    </div>
  )
}
